import React, { Component } from "react";
import Icon from "semantic-ui-react/dist/es/elements/Icon";
import VideoModal from "../../../UIComponents/VideoModal/VideoModal";
import "./PostImage.scss";
import instagramIcon from "../../../../assets/instagram_image.png";
import PlaceholderNsfw from "../../../../assets/PlaceholderNsfw.png";

class PostImage extends Component {
    constructor(props) {
        super(props);
        this.state = { videoPlaying: false, videoData: {}, showOriginalImage: false };
        this.timerId = null;
    }

    getVideoUrl = () => {
        let src = this.props.data.postVideoLink;
        if (src.indexOf("watch?v=") != "-1") {
            src = src.replace("watch?v=", "embed/");
            src += "?autoplay=1&wmode=transparent";
        }
        return src;
    };

    handleVideoPlay = () => {
        this.setState({
            videoPlaying: true,
            videoData: {
                url: this.getVideoUrl(this.props.data.postVideoLink),
                title: this.props.data.postTitle,
                platformName: this.props.data.platformName,
            },
        });
    };

    closeVideoModal = () => {
        this.setState({ videoPlaying: false, videoData: {} });
    };

    handleImageError = () => {
        this.postImage.src = instagramIcon;
    };

    handleImageClick = () => {
        this.setState((prevState) => ({ showOriginalImage: !prevState.showOriginalImage }));
        const isNsfw = this.props.data.postContentSafety === "NSFW" || this.props.data.postContentSafety === "NSFW_MANUAL";
        if (isNsfw) {
            this.postImage.style.cursor = "pointer";
        } else {
            this.postImage.style.cursor = "auto";
        }
        // setTimeout(() => {
        //     this.setState({ showOriginalImage: false });
        //     this.postImage.style.cursor = "auto";
        // }, 5000);
    };

    componentDidUpdate(prevProps) {
        if (this.props.data.postContentSafety === "NSFW" && prevProps.data.postContentSafety === "SFW") {
            this.setState({ showOriginalImage: false });
        }
    }

    render() {
        const { data, listView, dashboardPageType } = this.props;
        const { showOriginalImage } = this.state;
        const isNsfw = data.postContentSafety === "NSFW" || data.postContentSafety === "NSFW_MANUAL";
        const imageSource = isNsfw && !showOriginalImage ? PlaceholderNsfw : data.postImg;

        const imageClass = isNsfw && !showOriginalImage ? "post-image clickable-image" : "post-image";

        return (
            <div className={`post-image-container ${this.props.listView ? "post-image-container-listView" : ""}`}>
                <div className="image-container" onClick={this.handleImageClick}>
                    <img
                        // className="post-image"
                        className={imageClass}
                        src={imageSource}
                        onError={this.handleImageError}
                        ref={(el) => {
                            this.postImage = el;
                        }}
                        alt=""
                        crossOrigin="Anonymous"
                    />
                </div>

                {this.props.data.postMediaType === "VIDEO" &&
                    this.props.data.platformName !== "TikTok" &&
                    this.props.data.platformName !== "Facebook" &&
                    this.props.data.platformName !== "Instagram" &&
                    this.props.data.platformName !== "Facebook Comments" &&
                    this.props.dashboardPageType !== "SMP" && (
                        <>
                            <Icon name="video play" onClick={this.handleVideoPlay} size="huge" className={"video-play"} crossOrigin="" />
                            <VideoModal open={this.state.videoPlaying} hideModal={this.closeVideoModal} videoData={this.state.videoData} crossOrigin="" />
                        </>
                    )}
                {this.props.data.postMediaType === "VIDEO" &&
                    (this.props.dashboardPageType === "SMP" ||
                        this.props.data.platformName === "TikTok" ||
                        this.props.data.platformName === "Facebook" ||
                        this.props.data.platformName === "Instagram" ||
                        this.props.data.platformName === "Facebook Comments") && (
                        <a
                            target="_blank"
                            href={
                                this.props.data.platformName === "Instagram" ||
                                (this.props.dashboardPageType == "SMP" && this.props.data.platformName === "Twitter")
                                    ? this.props.data.postLink
                                    : this.props.data.postVideoLink
                            }
                            rel="noreferrer">
                            <Icon name="video play" size="huge" className="facebook-video-play video-play" crossOrigin="" />
                        </a>
                    )}
            </div>
        );
    }
}

export default PostImage;
